/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { ListLoyaltyPromotions200ResponsePromotionsInner } from './ListLoyaltyPromotions200ResponsePromotionsInner';
import {
    ListLoyaltyPromotions200ResponsePromotionsInnerFromJSON,
    ListLoyaltyPromotions200ResponsePromotionsInnerFromJSONTyped,
    ListLoyaltyPromotions200ResponsePromotionsInnerToJSON,
    instanceOfListLoyaltyPromotions200ResponsePromotionsInner,
} from './ListLoyaltyPromotions200ResponsePromotionsInner';

/**
 * 
 * @export
 * @interface ListLoyaltyPromotions200Response
 */
export interface ListLoyaltyPromotions200Response {
    /**
     * 
     * @type {Array<ListLoyaltyPromotions200ResponsePromotionsInner>}
     * @memberof ListLoyaltyPromotions200Response
     */
    promotions?: Array<ListLoyaltyPromotions200ResponsePromotionsInner>;
}


/**
 * Check if a given object implements the ListLoyaltyPromotions200Response interface.
 */
export function instanceOfListLoyaltyPromotions200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function ListLoyaltyPromotions200ResponseFromJSON(json: any): ListLoyaltyPromotions200Response {
    return ListLoyaltyPromotions200ResponseFromJSONTyped(json, false);
}

export function ListLoyaltyPromotions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLoyaltyPromotions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'promotions': !exists(json, 'promotions') ? undefined : ((json['promotions'] as Array<any>).map(ListLoyaltyPromotions200ResponsePromotionsInnerFromJSON)),
    };
}

export function ListLoyaltyPromotions200ResponseToJSON(value?: ListLoyaltyPromotions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'promotions': value.promotions === undefined ? undefined : ((value.promotions as Array<any>).map(ListLoyaltyPromotions200ResponsePromotionsInnerToJSON)),
    };
}

